import HighlightAltRoundedIcon from "@mui/icons-material/HighlightAltRounded";
import { IconButton } from "@mui/material";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";

interface Props {
  isPicking: boolean;
  disabled: boolean;
  title: string;
  onToggle: () => void;
}

const ArtifactAgentPickButton = ({ isPicking, disabled, title, onToggle }: Props) => (
  <TooltipForDisabledAction title={title} isActionDisabled={disabled}>
    <IconButton
      aria-label="Point at a part of the dashboard"
      aria-pressed={isPicking}
      color={isPicking ? "primary" : undefined}
      disabled={disabled}
      onClick={onToggle}
    >
      <HighlightAltRoundedIcon />
    </IconButton>
  </TooltipForDisabledAction>
);

export default ArtifactAgentPickButton;
